import { useDrag, useDrop } from 'react-dnd';
/** Represents a hook that handles drag/drop ordering of items. */
export const useOrderedDragDrop = ({ type, index, source, target, preview = source, onMove, canDrag, canDrop, triggerSwap = 'hover', }) => {
    const [{ isDragging }, connectSource, connectPreview] = useDrag(() => ({
        type,
        canDrag,
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [index]);
    const [{ isOver }, connectDrop] = useDrop({
        accept: type,
        canDrop,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
        [triggerSwap](item, monitor) {
            if (!source.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves.
            if (dragIndex === hoverIndex) {
                return;
            }
            if (monitor.canDrop()) {
                onMove({ dragIndex, hoverIndex });
            }
        },
    }, [index, onMove]);
    connectPreview(preview);
    connectSource(source);
    connectDrop(target);
    return { isDragging, isOver };
};
